// extracted by mini-css-extract-plugin
export var lightMode = "_i-0";